/* tslint:disable */
/* eslint-disable */
/**
 * bi-api
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface RequestOTPChallengeRequest
 */
export interface RequestOTPChallengeRequest {
    /**
     * 
     * @type {number}
     * @memberof RequestOTPChallengeRequest
     */
    business_ref: number;
    /**
     * 
     * @type {string}
     * @memberof RequestOTPChallengeRequest
     */
    email: string;
}

/**
 * Check if a given object implements the RequestOTPChallengeRequest interface.
 */
export function instanceOfRequestOTPChallengeRequest(value: object): value is RequestOTPChallengeRequest {
    if (!('business_ref' in value) || value['business_ref'] === undefined) return false;
    if (!('email' in value) || value['email'] === undefined) return false;
    return true;
}

export function RequestOTPChallengeRequestFromJSON(json: any): RequestOTPChallengeRequest {
    return RequestOTPChallengeRequestFromJSONTyped(json, false);
}

export function RequestOTPChallengeRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): RequestOTPChallengeRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'business_ref': json['business_ref'],
        'email': json['email'],
    };
}

export function RequestOTPChallengeRequestToJSON(json: any): RequestOTPChallengeRequest {
    return RequestOTPChallengeRequestToJSONTyped(json, false);
}

export function RequestOTPChallengeRequestToJSONTyped(value?: RequestOTPChallengeRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'business_ref': value['business_ref'],
        'email': value['email'],
    };
}

